import { render, staticRenderFns } from "./SalesNotCompleted.vue?vue&type=template&id=bd61128c"
import script from "./SalesNotCompleted.vue?vue&type=script&lang=js"
export * from "./SalesNotCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports